module.exports = __webpack_public_path__ + "img/jinhua.f3a2bb79.png";